import { useAuth0 } from "@auth0/auth0-react";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import AgribotAppBar from "@/components/layout/AppBar";
import { useActiveFarmContext, useApiContext } from "@/contexts";
import PageLoading from "./pages/loading";
import Router from "@/router/routes";
import { Auth0ErrorHandler } from "@/components/auth/Auth0ErrorHandler";

const App = () => {
  const { t } = useTranslation();
  const { isLoading } = useAuth0();
  const { loading: apiLoading, error: apiError } = useApiContext();
  const { farmsError } = useActiveFarmContext();

  if (isLoading || apiLoading) {
    return <PageLoading loadingText={t("initializingApp")} />;
  }

  return (
    <Box className="app-box" sx={{ width: "100%" }} data-testid="app-shell">
      <Auth0ErrorHandler />
      <AgribotAppBar>
        {farmsError && (
          <Alert severity="error" sx={{ mb: 2 }}>
            <Typography variant="body2">{t("unableToLoadFarms")}</Typography>
          </Alert>
        )}
        {apiError && (
          <Alert severity="error" sx={{ mb: 2 }}>
            <Typography variant="body2">{t("apiConnectionError")}</Typography>
          </Alert>
        )}
        <Box sx={{ width: "100%", display: "flex" }}>
          <Router />
        </Box>
      </AgribotAppBar>
    </Box>
  );
};

export default App;
